import { ConfigObj, Ajax, ExcessiveEvents, DomHelpers } from '../../utils/'

let _nextPageUrl = ''

let _$loading = null

const _defaultOpts = {
  nextPageUrl: '',
  offset: 0
}

const _createResImage = (sources = [{media: '', srcset: ''}]) => {
  return sources.map(source => {
    return `<source media="${source.media}" srcset="${source.srcset}">`
  }).join('')
}

const _getFormattedDate = timestamp => {
  const date = new Date(timestamp)
  const month =['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  return `${date.getDay()} ${month[date.getMonth()]} ${date.getFullYear()}`
}

export default class InfiniteScroll {
  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(_defaultOpts, opts)
    this.isLoading = false
  }

  init() {

    _$loading = document.createElement('div')
    _$loading.classList.add('ps-loading')
    _$loading.innerText = "loading"

    this.addEventListeners()

  }


  getItems(nextPageUrl) {

    this.$el.parentNode.appendChild(_$loading)

    Ajax.request(nextPageUrl, {
      requestHeaders: [
        { key: 'X-Requested-With', value: 'XMLHttpRequest' }
      ],
      onLoad: this.onAjaxLoad.bind(this)
    })

  }

   
  onAjaxLoad(response) {
    this.isLoading = false
    this.opts.nextPageUrl = response.nextPageUrl

    DomHelpers.destroyElement(_$loading)

    const postsMarkup = response.posts.map(post => {
      return `<div class="ps-article">
                    <div class="ps-responsive-image ps-article__image">
                        <a href="${post.url}">
                          <picture class="ps-responsive-image">
                              ${_createResImage(post.image.sources)}
                              <img alt="${post.image.img.alt}" src="${post.image.img.src}">
                          </picture>
                        </a>
                    </div>
                    <div class="ps-container">
                        <a href="${post.url}"><h2 class="ps-article__title">${post.title}</h2></a>
                        <div class="ps-date-category"><span title="${post.authoredDate}" class="ps-date-category__date">${_getFormattedDate(post.authoredDate)}</span>
                        <a href="${post.categoryUrl}" class="ps-date-category__category">${post.categoryName}</a>
                    </div>
                        ${post.intro != null || post.intro == '' ? '<p>' + post.intro + '</p>' : ''}
                    </div>
                </div>`
    })

    this.$el.insertAdjacentHTML('beforeend', postsMarkup.join(''))

  }


  onScroll() {
    // If the last row of items are in view, load more
    // If is end of file (no more items to load) do nothing
    if (this.isLoading || this.opts.nextPageUrl == null || this.opts.nextPageUrl == '') return

    const dimension = this.$el.getBoundingClientRect()
    if (dimension.bottom <= window.innerHeight + this.opts.offset) this.getItems(this.opts.nextPageUrl)
  }

  addEventListeners() {
    window.addEventListener('scroll', ExcessiveEvents.debounce(this.onScroll.bind(this), 500))
  }
}



// WEBPACK FOOTER //
// ./js/blog/modules/InfiniteScroll.js